import Routes from './routes'
import 'windi.css'
import '../../assets/css/index.scss'

export default {
  // name version 必须为字面常量
  name: 'portal-management-nanhai',
  title: '门户管理',
  version: '0.1.7',
  description: '包含门户系统管理、门户配置、采集管理、栏目发布等模块',
  routes: Routes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: ['RoyaltiesTargetStatisticsApi', 'OrganizationApi', 'RoyaltiesTargetApi'],
  },
  config: {},
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
